export const countries = [
  { code: "us", dial_code: "+1", name: "countryUS", selected: true },
  { code: "AF", dial_code: "+93", name: "countryAF" },
  { code: "AL", dial_code: "+355", name: "countryAL" },
  { code: "DZ", dial_code: "+213", name: "countryDZ" },
  { code: "AS", dial_code: "+1 684", name: "countryAS" },
  { code: "AD", dial_code: "+376", name: "countryAD" },
  { code: "AO", dial_code: "+244", name: "countryAO" },
  { code: "AI", dial_code: "+1 264", name: "countryAI" },
  { code: "AG", dial_code: "+1268", name: "countryAG" },
  { code: "AR", dial_code: "+54", name: "countryAR" },
  { code: "AM", dial_code: "+374", name: "countryAM" },
  { code: "AW", dial_code: "+297", name: "countryAW" },
  { code: "AU", dial_code: "+61", name: "countryAU" },
  { code: "AT", dial_code: "+43", name: "countryAT" },
  { code: "AZ", dial_code: "+994", name: "countryAZ" },
  { code: "BS", dial_code: "+1 242", name: "countryBS" },
  { code: "BH", dial_code: "+973", name: "countryBH" },
  { code: "BD", dial_code: "+880", name: "countryBD" },
  { code: "BB", dial_code: "+1 246", name: "countryBB" },
  { code: "BY", dial_code: "+375", name: "countryBY" },
  { code: "BE", dial_code: "+32", name: "countryBE" },
  { code: "BZ", dial_code: "+501", name: "countryBZ" },
  { code: "BJ", dial_code: "+229", name: "countryBJ" },
  { code: "BM", dial_code: "+1 441", name: "countryBM" },
  { code: "BT", dial_code: "+975", name: "countryBT" },
  { code: "BA", dial_code: "+387", name: "countryBA" },
  { code: "BW", dial_code: "+267", name: "countryBW" },
  { code: "BR", dial_code: "+55", name: "countryBR" },
  { code: "IO", dial_code: "+246", name: "countryIO" },
  { code: "BG", dial_code: "+359", name: "countryBG" },
  { code: "BF", dial_code: "+226", name: "countryBF" },
  { code: "BI", dial_code: "+257", name: "countryBI" },
  { code: "KH", dial_code: "+855", name: "countryKH" },
  { code: "CM", dial_code: "+237", name: "countryCM" },
  { code: "CA", dial_code: "+1", name: "countryCA" },
  { code: "CV", dial_code: "+238", name: "countryCV" },
  { code: "KY", dial_code: "+1 345", name: "countryKY" },
  { code: "CF", dial_code: "+236", name: "countryCF" },
  { code: "TD", dial_code: "+235", name: "countryTD" },
  { code: "CL", dial_code: "+56", name: "countryCL" },
  { code: "CN", dial_code: "+86", name: "countryCN" },
  { code: "CX", dial_code: "+61", name: "countryCX" },
  { code: "CO", dial_code: "+57", name: "countryCO" },
  { code: "KM", dial_code: "+269", name: "countryKM" },
  { code: "CG", dial_code: "+242", name: "countryCG" },
  { code: "CK", dial_code: "+682", name: "countryCK" },
  { code: "CR", dial_code: "+506", name: "countryCR" },
  { code: "HR", dial_code: "+385", name: "countryHR" },
  { code: "CU", dial_code: "+53", name: "countryCU" },
  { code: "CY", dial_code: "+537", name: "countryCY" },
  { code: "CZ", dial_code: "+420", name: "countryCZ" },
  { code: "DK", dial_code: "+45", name: "countryDK" },
  { code: "DJ", dial_code: "+253", name: "countryDJ" },
  { code: "DM", dial_code: "+1 767", name: "countryDM" },
  { code: "DO", dial_code: "+1 849", name: "countryDO" },
  { code: "EC", dial_code: "+593", name: "countryEC" },
  { code: "EG", dial_code: "+20", name: "countryEG" },
  { code: "SV", dial_code: "+503", name: "countrySV" },
  { code: "GQ", dial_code: "+240", name: "countryGQ" },
  { code: "ER", dial_code: "+291", name: "countryER" },
  { code: "EE", dial_code: "+372", name: "countryEE" },
  { code: "ET", dial_code: "+251", name: "countryET" },
  { code: "FO", dial_code: "+298", name: "countryFO" },
  { code: "FJ", dial_code: "+679", name: "countryFJ" },
  { code: "FI", dial_code: "+358", name: "countryFI" },
  { code: "FR", dial_code: "+33", name: "countryFR" },
  { code: "GF", dial_code: "+594", name: "countryGF" },
  { code: "PF", dial_code: "+689", name: "countryPF" },
  { code: "GA", dial_code: "+241", name: "countryGA" },
  { code: "GM", dial_code: "+220", name: "countryGM" },
  { code: "GE", dial_code: "+995", name: "countryGE" },
  { code: "DE", dial_code: "+49", name: "countryDE" },
  { code: "GH", dial_code: "+233", name: "countryGH" },
  { code: "GI", dial_code: "+350", name: "countryGI" },
  { code: "GR", dial_code: "+30", name: "countryGR" },
  { code: "GL", dial_code: "+299", name: "countryGL" },
  { code: "GD", dial_code: "+1 473", name: "countryGD" },
  { code: "GP", dial_code: "+590", name: "countryGP" },
  { code: "GU", dial_code: "+1 671", name: "countryGU" },
  { code: "GT", dial_code: "+502", name: "countryGT" },
  { code: "GN", dial_code: "+224", name: "countryGN" },
  { code: "GW", dial_code: "+245", name: "countryGW" },
  { code: "GY", dial_code: "+595", name: "countryGY" },
  { code: "HT", dial_code: "+509", name: "countryHT" },
  { code: "HN", dial_code: "+504", name: "countryHN" },
  { code: "HU", dial_code: "+36", name: "countryHU" },
  { code: "IS", dial_code: "+354", name: "countryIS" },
  { code: "IN", dial_code: "+91", name: "countryIN" },
  { code: "ID", dial_code: "+62", name: "countryID" },
  { code: "IQ", dial_code: "+964", name: "countryIQ" },
  { code: "IE", dial_code: "+353", name: "countryIE" },
  { code: "IL", dial_code: "+972", name: "countryIL" },
  { code: "IT", dial_code: "+39", name: "countryIT" },
  { code: "JM", dial_code: "+1 876", name: "countryJM" },
  { code: "JP", dial_code: "+81", name: "countryJP" },
  { code: "JO", dial_code: "+962", name: "countryJO" },
  { code: "KZ", dial_code: "+7 7", name: "countryKZ" },
  { code: "KE", dial_code: "+254", name: "countryKE" },
  { code: "KI", dial_code: "+686", name: "countryKI" },
  { code: "KW", dial_code: "+965", name: "countryKW" },
  { code: "KG", dial_code: "+996", name: "countryKG" },
  { code: "LV", dial_code: "+371", name: "countryLV" },
  { code: "LB", dial_code: "+961", name: "countryLB" },
  { code: "LS", dial_code: "+266", name: "countryLS" },
  { code: "LR", dial_code: "+231", name: "countryLR" },
  { code: "LI", dial_code: "+423", name: "countryLI" },
  { code: "LT", dial_code: "+370", name: "countryLT" },
  { code: "LU", dial_code: "+352", name: "countryLU" },
  { code: "MG", dial_code: "+261", name: "countryMG" },
  { code: "MW", dial_code: "+265", name: "countryMW" },
  { code: "MY", dial_code: "+60", name: "countryMY" },
  { code: "MV", dial_code: "+960", name: "countryMV" },
  { code: "ML", dial_code: "+223", name: "countryML" },
  { code: "MT", dial_code: "+356", name: "countryMT" },
  { code: "MH", dial_code: "+692", name: "countryMH" },
  { code: "MQ", dial_code: "+596", name: "countryMQ" },
  { code: "MR", dial_code: "+222", name: "countryMR" },
  { code: "MU", dial_code: "+230", name: "countryMU" },
  { code: "YT", dial_code: "+262", name: "countryYT" },
  { code: "MX", dial_code: "+52", name: "countryMX" },
  { code: "MC", dial_code: "+377", name: "countryMC" },
  { code: "MN", dial_code: "+976", name: "countryMN" },
  { code: "ME", dial_code: "+382", name: "countryME" },
  { code: "MS", dial_code: "+1664", name: "countryMS" },
  { code: "MA", dial_code: "+212", name: "countryMA" },
  { code: "MM", dial_code: "+95", name: "countryMM" },
  { code: "NA", dial_code: "+264", name: "countryNA" },
  { code: "NR", dial_code: "+674", name: "countryNR" },
  { code: "NP", dial_code: "+977", name: "countryNP" },
  { code: "NL", dial_code: "+31", name: "countryNL" },
  { code: "AN", dial_code: "+599", name: "countryAN" },
  { code: "NC", dial_code: "+687", name: "countryNC" },
  { code: "NZ", dial_code: "+64", name: "countryNZ" },
  { code: "NI", dial_code: "+505", name: "countryNI" },
  { code: "NE", dial_code: "+227", name: "countryNE" },
  { code: "NG", dial_code: "+234", name: "countryNG" },
  { code: "NU", dial_code: "+683", name: "countryNU" },
  { code: "NF", dial_code: "+672", name: "countryNF" },
  { code: "MP", dial_code: "+1 670", name: "countryMP" },
  { code: "NO", dial_code: "+47", name: "countryNO" },
  { code: "OM", dial_code: "+968", name: "countryOM" },
  { code: "PK", dial_code: "+92", name: "countryPK" },
  { code: "PW", dial_code: "+680", name: "countryPW" },
  { code: "PA", dial_code: "+507", name: "countryPA" },
  { code: "PG", dial_code: "+675", name: "countryPG" },
  { code: "PY", dial_code: "+595", name: "countryPY" },
  { code: "PE", dial_code: "+51", name: "countryPE" },
  { code: "PH", dial_code: "+63", name: "countryPH" },
  { code: "PL", dial_code: "+48", name: "countryPL" },
  { code: "PT", dial_code: "+351", name: "countryPT" },
  { code: "PR", dial_code: "+1 939", name: "countryPR" },
  { code: "QA", dial_code: "+974", name: "countryQA" },
  { code: "RO", dial_code: "+40", name: "countryRO" },
  { code: "RW", dial_code: "+250", name: "countryRW" },
  { code: "WS", dial_code: "+685", name: "countryWS" },
  { code: "SM", dial_code: "+378", name: "countrySM" },
  { code: "SA", dial_code: "+966", name: "countrySA" },
  { code: "SN", dial_code: "+221", name: "countrySN" },
  { code: "RS", dial_code: "+381", name: "countryRS" },
  { code: "SC", dial_code: "+248", name: "countrySC" },
  { code: "SL", dial_code: "+232", name: "countrySL" },
  { code: "SG", dial_code: "+65", name: "countrySG" },
  { code: "SK", dial_code: "+421", name: "countrySK" },
  { code: "SI", dial_code: "+386", name: "countrySI" },
  { code: "SB", dial_code: "+677", name: "countrySB" },
  { code: "ZA", dial_code: "+27", name: "countryZA" },
  { code: "GS", dial_code: "+500", name: "countryGS" },
  { code: "ES", dial_code: "+34", name: "countryES" },
  { code: "LK", dial_code: "+94", name: "countryLK" },
  { code: "SD", dial_code: "+249", name: "countrySD" },
  { code: "SR", dial_code: "+597", name: "countrySR" },
  { code: "SZ", dial_code: "+268", name: "countrySZ" },
  { code: "SE", dial_code: "+46", name: "countrySE" },
  { code: "CH", dial_code: "+41", name: "countryCH" },
  { code: "TJ", dial_code: "+992", name: "countryTJ" },
  { code: "TH", dial_code: "+66", name: "countryTH" },
  { code: "TG", dial_code: "+228", name: "countryTG" },
  { code: "TK", dial_code: "+690", name: "countryTK" },
  { code: "TO", dial_code: "+676", name: "countryTO" },
  { code: "TT", dial_code: "+1 868", name: "countryTT" },
  { code: "TN", dial_code: "+216", name: "countryTN" },
  { code: "TR", dial_code: "+90", name: "countryTR" },
  { code: "TM", dial_code: "+993", name: "countryTM" },
  { code: "TC", dial_code: "+1 649", name: "countryTC" },
  { code: "TV", dial_code: "+688", name: "countryTV" },
  { code: "UG", dial_code: "+256", name: "countryUG" },
  { code: "UA", dial_code: "+380", name: "countryUA" },
  { code: "AE", dial_code: "+971", name: "countryAE" },
  { code: "GB", dial_code: "+44", name: "countryGB" },
  { code: "UY", dial_code: "+598", name: "countryUY" },
  { code: "UZ", dial_code: "+998", name: "countryUZ" },
  { code: "VU", dial_code: "+678", name: "countryVU" },
  { code: "WF", dial_code: "+681", name: "countryWF" },
  { code: "YE", dial_code: "+967", name: "countryYE" },
  { code: "ZM", dial_code: "+260", name: "countryZM" },
  { code: "ZW", dial_code: "+263", name: "countryZW" },
  { code: "AX", dial_code: "+358", name: "countryAX" },
  { code: "BO", dial_code: "+591", name: "countryBO" },
  { code: "BN", dial_code: "+673", name: "countryBN" },
  { code: "CC", dial_code: "+61", name: "countryCC" },
  { code: "CD", dial_code: "+243", name: "countryCD" },
  { code: "CI", dial_code: "+225", name: "countryCI" },
  { code: "FK", dial_code: "+500", name: "countryFK" },
  { code: "GG", dial_code: "+44", name: "countryGG" },
  { code: "VA", dial_code: "+379", name: "countryVA" },
  { code: "HK", dial_code: "+852", name: "countryHK" },
  { code: "IR", dial_code: "+98", name: "countryIR" },
  { code: "IM", dial_code: "+44", name: "countryIM" },
  { code: "JE", dial_code: "+44", name: "countryJE" },
  { code: "KP", dial_code: "+850", name: "countryKP" },
  { code: "KR", dial_code: "+82", name: "countryKR" },
  { code: "LA", dial_code: "+856", name: "countryLA" },
  { code: "LY", dial_code: "+218", name: "countryLY" },
  { code: "MO", dial_code: "+853", name: "countryMO" },
  { code: "MK", dial_code: "+389", name: "countryMK" },
  { code: "FM", dial_code: "+691", name: "countryFM" },
  { code: "MD", dial_code: "+373", name: "countryMD" },
  { code: "MZ", dial_code: "+258", name: "countryMZ" },
  { code: "PS", dial_code: "+970", name: "countryPS" },
  { code: "PN", dial_code: "+872", name: "countryPN" },
  { code: "RE", dial_code: "+262", name: "countryRE" },
  { code: "RU", dial_code: "+7", name: "countryRU" },
  { code: "BL", dial_code: "+590", name: "countryBL" },
  { code: "SH", dial_code: "+290", name: "countrySH" },
  { code: "KN", dial_code: "+1 869", name: "countryKN" },
  { code: "LC", dial_code: "+1 758", name: "countryLC" },
  { code: "MF", dial_code: "+590", name: "countryMF" },
  { code: "PM", dial_code: "+508", name: "countryPM" },
  { code: "VC", dial_code: "+1 784", name: "countryVC" },
  { code: "ST", dial_code: "+239", name: "countryST" },
  { code: "SO", dial_code: "+252", name: "countrySO" },
  { code: "SJ", dial_code: "+47", name: "countrySJ" },
  { code: "SY", dial_code: "+963", name: "countrySY" },
  { code: "TW", dial_code: "+886", name: "countryTW" },
  { code: "TZ", dial_code: "+255", name: "countryTZ" },
  { code: "TL", dial_code: "+670", name: "countryTL" },
  { code: "VE", dial_code: "+58", name: "countryVE" },
  { code: "VN", dial_code: "+84", name: "countryVN" },
  { code: "VG", dial_code: "+1 284", name: "countryVG" },
  { code: "VI", dial_code: "+1 340", name: "countryVI" },
];
